module.exports = __webpack_public_path__ + "static/media/About_Entertainment.f0be18e3.svg";